var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EqsCard',_vm._g(_vm._b({staticClass:"fill-height",scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('EqsStepper',_vm._b({staticStyle:{"height":"100%"},attrs:{"value":_vm.step},on:{"update:value":function($event){_vm.step=$event},"close":_vm.comeBackToSecondaryMarket},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c(item.is,_vm._b({tag:"component",on:{"error":e => {
                            _vm.catchError();
                        },"signatureRefused":_vm.signatureRefused}},'component',{
                        formData: _vm.formData,
                        buyer: _vm.buyer,
                        signer: _vm.signer,
                        operationId: _vm.operationId,
                        stepperState: _vm.stepperState,
                        documents: _vm.documents,
                        order: _vm.order,
                        quantity: _vm.quantity,
                        total: _vm.total,
                        schemaDouble: _vm.schemaDouble
                    },false))]}}])},'EqsStepper',{
                steps: _vm.steps,
                progress: _vm.progress,
                closeInfoTxt: _vm.$t('secondary-market.buy-stepper.dialog-signatory.cancel-btn')
            },false))]},proxy:true}])},'EqsCard',{ height: '100%', loading: _vm.loading || _vm.localLoading },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }